(() => {
  'use strict';

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const initialiseRecipientForm = (root) => {
    if (root.dataset.rvRecipientReady === 'true') return;

    const toggle = root.querySelector('[data-rv-recipient-toggle]');
    const fields = root.querySelector('[data-rv-recipient-fields]');
    const inputs = [...root.querySelectorAll('[data-rv-recipient-input]')];
    const email = root.querySelector('[data-rv-recipient-email]');
    const message = root.querySelector('[data-rv-recipient-message]');
    const count = root.querySelector('[data-rv-recipient-count]');
    const sendOn = root.querySelector('[data-rv-recipient-date]');
    const offset = root.querySelector('[data-rv-recipient-offset]');

    if (!toggle || !fields || !email) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const latest = new Date(today);
    latest.setDate(latest.getDate() + 90);
    const minimumDate = formatLocalDate(today);
    const maximumDate = formatLocalDate(latest);

    if (sendOn) {
      sendOn.min = minimumDate;
      sendOn.max = maximumDate;
    }
    if (offset) offset.value = String(new Date().getTimezoneOffset());

    const updateCount = () => {
      if (message && count) count.textContent = `${message.value.length}/200`;
    };

    const validateDate = () => {
      if (!sendOn || !sendOn.value) {
        sendOn?.setCustomValidity('');
        return;
      }
      const withinRange = sendOn.value >= minimumDate && sendOn.value <= maximumDate;
      sendOn.setCustomValidity(
        withinRange ? '' : 'Choose a date from today up to 90 days from now.'
      );
    };

    const setActive = (active) => {
      fields.hidden = !active;
      toggle.setAttribute('aria-expanded', String(active));
      inputs.forEach((input) => {
        input.disabled = !active;
      });
      email.required = active;
      if (active && offset) offset.value = String(new Date().getTimezoneOffset());
      if (!active) sendOn?.setCustomValidity('');
    };

    toggle.addEventListener('change', () => {
      setActive(toggle.checked);
      if (toggle.checked) window.requestAnimationFrame(() => email.focus({ preventScroll: true }));
    });
    message?.addEventListener('input', updateCount);
    sendOn?.addEventListener('change', validateDate);
    sendOn?.addEventListener('input', validateDate);

    setActive(toggle.checked);
    updateCount();
    validateDate();
    root.dataset.rvRecipientReady = 'true';
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-rv-gift-card-recipient]').forEach(initialiseRecipientForm);
  };

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
